import { action, makeObservable, observable, computed } from "mobx";
import { fabric } from "fabric";
import _ from "lodash";
import RootStore from "store/rootStore";
import {
  getSensSelectedPoints,
  insertTable,
  IsPolygonCrossing,
  replaceValueswithNull,
  valBetweenPoints,
} from "./stickTwoPolygonsUtils";

class StickTwoPolygonsStore {
  constructor(private store: RootStore) {
    makeObservable(this);
  }

  @observable stickMode: boolean = false;
  @observable firstStickPolygon: string | null = null;
  @observable firstStickIndexes: number[] | null = null;
  @observable firstPolyStickPoints: fabric.Point[] = [];
  @observable firstPolyFinished: boolean = false;

  @observable secondStickPolygon: string | null = null;
  @observable secondStickIndexes: number[] | null = null;
  @observable secondPolyStickPoints: fabric.Point[] = [];
  @observable secondPolyFinished: boolean = false;

  @observable stickFinished: boolean = false;
  @observable polygonsBeforeStick: any[] = [];

  @action selectPointFirstPolygon = (pointIndex: number, poly: any) => {
    // Set first point of first polygon
    if (this.firstStickIndexes === null) {
      this.setFirstStickPolygon(poly.labelValue);
      this.setFirstStickIndexes([pointIndex]);
      this.store.fabricSegmentationStore.canvas.add(
        new fabric.Circle({
          left: poly.points[pointIndex].x - 10,
          top: poly.points[pointIndex].y - 10,
          radius: 10,
          fill: "orange",
        })
      );
    } else if (
      // Set last point of first polygon
      this.firstStickIndexes !== null &&
      this.firstStickIndexes.length === 1 &&
      this.firstStickPolygon === poly.labelValue
    ) {
      if (this.firstStickIndexes[0] !== pointIndex) {
        this.setFirstStickIndexes([...this.firstStickIndexes, pointIndex]);
        this.store.fabricSegmentationStore.canvas.add(
          new fabric.Circle({
            left: poly.points[pointIndex].x - 10,
            top: poly.points[pointIndex].y - 10,
            radius: 10,
            fill: "orange",
          })
        );
      }
    } else if (
      this.firstStickIndexes !== null &&
      this.firstStickIndexes.length === 2 &&
      this.firstStickPolygon === poly.labelValue
    ) {
      const pointDebut = this.firstStickIndexes[0];
      const pointSens = this.firstStickIndexes[1];

      this.setFirstStickIndexes([...this.firstStickIndexes, pointIndex]);

      const sens = getSensSelectedPoints(
        pointDebut,
        pointSens,
        pointIndex,
        poly.points.length
      );

      this.setFirstPolyStickPoints(
        valBetweenPoints(
          poly.points,
          this.firstStickIndexes[0],
          sens,
          pointIndex
        )
      );

      valBetweenPoints(
        poly.points,
        this.firstStickIndexes[0],
        sens,
        pointIndex
      ).map((p: { x: number; y: number }) => {
        this.store.fabricSegmentationStore.canvas.add(
          new fabric.Circle({
            left: p.x - 10,
            top: p.y - 10,
            radius: 10,
            fill: "orange",
          })
        );
      });
      this.setFirstPolyFinished(true);
    }
  };

  @action selectPointSecondPolygon = (pointIndex: number, poly: any) => {
    const { polygons, setPolygons } = this.store.labelerSegmentationUiStore;

    // Set second point of second polygon
    if (
      this.secondStickIndexes === null &&
      this.firstPolyFinished === true &&
      poly.labelValue !== this.firstStickPolygon
    ) {
      this.setSecondStickPolygon(poly.labelValue);
      this.setSecondStickIndexes([pointIndex]);
      this.store.fabricSegmentationStore.canvas.add(
        new fabric.Circle({
          left: poly.points[pointIndex].x - 10,
          top: poly.points[pointIndex].y - 10,
          radius: 10,
          fill: "red",
        })
      );
    } else if (
      // Set last point of second polygon
      this.secondStickIndexes !== null &&
      this.secondStickIndexes.length === 1 &&
      this.secondStickPolygon === poly.labelValue
    ) {
      if (this.secondStickIndexes[0] !== pointIndex) {
        this.setSecondStickIndexes([...this.secondStickIndexes, pointIndex]);
        this.store.fabricSegmentationStore.canvas.add(
          new fabric.Circle({
            left: poly.points[pointIndex].x - 10,
            top: poly.points[pointIndex].y - 10,
            radius: 10,
            fill: "red",
          })
        );
      }
    } else if (
      this.secondStickIndexes !== null &&
      this.secondStickIndexes.length === 2 &&
      this.secondStickPolygon === poly.labelValue
    ) {
      const pointDebut = this.secondStickIndexes[0];
      const pointSens = this.secondStickIndexes[1];

      const sens = getSensSelectedPoints(
        pointDebut,
        pointSens,
        pointIndex,
        poly.points.length
      );

      this.setSecondPolyStickPoints(
        valBetweenPoints(
          poly.points,
          this.secondStickIndexes[0],
          sens,
          pointIndex
        )
      );

      valBetweenPoints(
        poly.points,
        this.secondStickIndexes[0],
        sens,
        pointIndex
      ).map((p: { x: number; y: number }) => {
        this.store.fabricSegmentationStore.canvas.add(
          new fabric.Circle({
            left: p.x - 10,
            top: p.y - 10,
            radius: 10,
            fill: "red",
          })
        );
      });

      const poly2WithNull = replaceValueswithNull(
        poly.points,
        valBetweenPoints(
          poly.points,
          this.secondStickIndexes[0],
          sens,
          pointIndex
        )
      );

      this.setSecondPolyFinished(true);

      let poly2WithNewPoints = insertTable(
        poly2WithNull,
        //@ts-ignore
        _.min([...this.secondStickIndexes, pointIndex]),
        this.firstPolyStickPoints
      ).filter((p: any) => p !== null);

      if (IsPolygonCrossing(poly2WithNewPoints as fabric.Point[])) {
        poly2WithNewPoints = insertTable(
          poly2WithNull,
          //@ts-ignore
          _.min([...this.secondStickIndexes, pointIndex]),
          this.firstPolyStickPoints.reverse()
        ).filter((p: any) => p !== null);
      }

      this.setPolygonsBeforeStick([...polygons]);

      setPolygons(
        polygons.map((poly: any, i: number) => {
          if (poly.labelValue === this.secondStickPolygon) {
            return {
              ...poly,
              points: [...poly2WithNewPoints],
            };
          } else {
            return poly;
          }
        })
      );
      this.setStickFinished(true);
      this.resetPolyStick();
    }
  };

  /////// SETTERS //////////////////

  @action setFirstStickIndexes = (firstStickIndexes: number[] | null) => {
    this.firstStickIndexes = firstStickIndexes;
  };

  @action setFirstPolyStickPoints = (firstPolyStickPoints: fabric.Point[]) => {
    this.firstPolyStickPoints = firstPolyStickPoints;
  };

  @action setFirstStickPolygon = (firstStickPolygon: string | null) => {
    this.firstStickPolygon = firstStickPolygon;
  };

  @action setFirstPolyFinished = (firstPolyFinished: boolean) => {
    this.firstPolyFinished = firstPolyFinished;
  };

  @action setSecondStickIndexes = (secondStickIndexes: number[] | null) => {
    this.secondStickIndexes = secondStickIndexes;
  };

  @action setSecondPolyStickPoints = (
    secondPolyStickPoints: fabric.Point[]
  ) => {
    this.secondPolyStickPoints = secondPolyStickPoints;
  };

  @action setSecondStickPolygon = (secondStickPolygon: string | null) => {
    this.secondStickPolygon = secondStickPolygon;
  };

  @action setSecondPolyFinished = (secondPolyFinished: boolean) => {
    this.secondPolyFinished = secondPolyFinished;
  };

  @action resetPolyStick = () => {
    const { canvas } = this.store.fabricSegmentationStore;

    this.setFirstPolyStickPoints([]);
    this.setFirstStickIndexes(null);
    this.setSecondPolyStickPoints([]);
    this.setSecondStickIndexes(null);
    this.setFirstPolyFinished(false);
    this.setSecondPolyFinished(false);
    this.setStickMode(false);

    canvas.forEachObject(function(obj) {
      if (obj instanceof fabric.Circle) {
        canvas.remove(obj);
      }
    });
    canvas.renderAll();
  };

  @action setStickMode = (stickMode: boolean) => {
    const { canvas, drawPolygon } = this.store.fabricSegmentationStore;
    const { polygons } = this.store.labelerSegmentationUiStore;

    this.stickMode = stickMode;
    canvas.renderAll();

    polygons.forEach((p: any) => drawPolygon(p));
  };

  @action setStickFinished = (stickFinished: boolean) => {
    this.stickFinished = stickFinished;
  };

  @action setPolygonsBeforeStick = (polygonsBeforeStick: any[]) => {
    this.polygonsBeforeStick = polygonsBeforeStick;
  };
}

export default StickTwoPolygonsStore;
